<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-row class="mx-2 my-3 text-primary">
      <b-col cols="12" lg="7">
        <h4>
          <i :class="new Date().getHours() < 18 ? 'fa fa-sun-o' : 'fa fa-moon-o'"></i>
          {{ greeting }} {{ user.firstname }}
        </h4>
      </b-col>
      <b-col v-if="onstopclients.length > 0" cols="12" lg="4">
        <h6>
          <i class="fa fa-handshake-o"></i>
          Clients on stop:
        </h6>
        <!-- <span class=" text-primary">
          Clients on stop:
        </span> -->
        <span :id="client.slac" v-for="(client, index) in onstopclients" :key="index" class="badge badge-danger mr-1">
          {{ client.slac }}
          <b-tooltip :target="client.slac" triggers="hover" placement="bottom">{{ client.name }}</b-tooltip>
        </span>
      </b-col>
      <!-- <b-col v-if="onstopsuppliers.length > 0" cols="12" lg="4">
        <h4>Suppliers on stop:</h4>
        <span
          :id="supplier.blac"
          v-for="(supplier, index) in onstopsuppliers"
          :key="index"
          class="badge badge-danger mr-1"
        >
          {{ supplier.blac }}
          <b-tooltip
            :target="supplier.blac"
            triggers="hover"
            placement="bottom"
            >{{ supplier.name }}</b-tooltip
          >
        </span>
      </b-col> -->
      <!-- <b-col
        v-if="user.permissions.includes('systems.x')"
        cols="12"
        lg="4"
      > -->
      <!-- <b-card
          no-body
          class="overflow-hidden"
          :style="'min-height: 100px;cursor: pointer;'"
          @click="$bvModal.show('draftinvoices-wizard')"
        >
          <b-row class="m-2" no-gutters>
            <b-col md="2">
              <b-card-img
                src="/img/brand/invoice.png"
                alt="Image"
                class="rounded-0"
              ></b-card-img>
            </b-col>
            <b-col md="8">
              <b-card-body title="Draft invoicing wizard ...">
                <b-card-text
                  >Invoicing our clients for flights, hotels and cars.
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card> -->
      <!-- <b-button
          @click="$bvModal.show('draftinvoices-wizard')"
          squared
          variant="outline-light"
          class="m-0 "
        >
          <b-row no-gutters align-v="center" class="text-left">
            <b-col cols="2">
              <b-card-img
                src="/img/brand/invoice.png"
                alt="Image"
                class="rounded-0"
              ></b-card-img>
            </b-col>
            <b-col cols="10" class="pl-2">
              <b-card-body class="text-primary" title="Invoicing wizard ...">
                <b-card-text class="text-primary"
                  >Invoicing our clients for flights, hotels and cars.
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-button> -->
      <!-- </b-col> -->
    </b-row>
    <div class="eventcalendar">
      <b-card class="mt-2 mx-0 border-none p-0">
        <b-tooltip target="eventcalendar-info" triggers="hover">Change month or click on day to see the
          events</b-tooltip>
        <b-card-body class="px-0">
          <div v-if="window.width >= 1024">
            <splitpanes class="default-theme" @resize="paneSize = $event[0].size">
              <!-- <pane min-size="20" max-size="30" :size="pane1" v-if="invalid">
                <TickZhold />
              </pane> -->
              <pane min-size="60" max-size="100" :size="pane2">
                <b-card-body v-if="chartData" class="p-0 mr-2">
                  <CalendarSinglepick v-model="selected" :data="chartData" :options="chartOptions"
                    @selectDay="selectedDay" @changeMonth="changeMonth" />
                </b-card-body>
                <b-row>
                  <b-col>
                    <span class="text-secondary" v-if="chartData">
                      {{ chartData.total }} event(s) were found.
                    </span>
                  </b-col>
                  <b-col cols="auto">
                    <b-link @click="download(selected)" class="text-secondary mr-3">
                      <i class="fa fa-calendar text-secondary"></i>
                      Download .ics file
                    </b-link>
                  </b-col>
                </b-row>
              </pane>
              <pane :size="100 - (pane1 + pane2)">
                <b-card-body class="p-0 ml-2">
                  <b-row>
                    <b-col cols="auto" class="mr-auto">
                      <b-navbar toggleable="sm" type="light" variant="light" class="pl-0 bg-transparent"
                        id="eventcalendar-info2">
                        <b-navbar-brand class="text-primary text-right">{{
                          $moment(selected).format("dddd Do MMMM YYYY")
                        }}</b-navbar-brand>
                      </b-navbar>
                      <b-tooltip target="eventcalendar-info2" triggers="hover">Change month or click on day to see the
                        events</b-tooltip>
                    </b-col>
                    <!-- <b-col cols="12" class="mt-2">
                      <b-form-group size="sm">
                        <b-input-group>
                          <b-form-input size="sm" v-model="find" placeholder="Find"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" style="width: auto; padding: 0.25rem 0.6rem" variant="outline-primary"
                              :disabled="!find" @click="find = ''">
                              <i v-if="find" class="fa fa-remove"></i>
                              <i v-if="!find" class="fa fa-search"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col> -->
                  </b-row>
                  <b-table ref="eventtable" id="eventtable" striped fixed small bordered :items="items" :fields="fields"
                    :filter="find" :per-page="perPage" :current-page="currentPage" class="eventtable gridtable">
                    <template v-slot:cell()="row">
                      <div v-if="row.field.key == 'event'">
                        {{ row.item.eventcode }} ( {{ row.item.description }} )
                      </div>
                      <div v-else>{{ row.value }}</div>
                    </template>
                  </b-table>

                  <b-row class="text-left text-muted small" no-gutters>
                    <b-col v-if="items.length > 0" class="pl-2">Showing {{ items.length }} event(s)</b-col>
                    <b-col v-if="!items.length > 0" class="pl-2">There are no events to display</b-col>
                    <b-col>
                      <b-pagination v-if="items.length > 0" aria-controls="eventtable" v-model="currentPage"
                        :total-rows="items.length" :per-page="perPage" size="sm" align="right"
                        hide-ellipsis></b-pagination>
                    </b-col>
                  </b-row>
                  <b-row v-if="chartOptions" class="mt-2 pl-2">
                    <b-col class="legend" cols="6" xl="4" v-for="(group, index) in criteria.groups" :key="index">
                      <div :class="'inline mt-1 border-secondary bg-' + group.bootstrap
                        " @click="toggleGroup(group.id)"></div>
                      <span class="text-secondary pl-1" :style="search.group.includes(group.id)
                        ? null
                        : 'text-decoration:line-through'
                        " @click="toggleGroup(group.id)">{{ group.id }}</span>
                    </b-col>
                  </b-row>
                  <b-row class="text-left text-muted small" no-gutters>
                    <b-col class="pl-2 mt-2">Click to toggle display</b-col>
                  </b-row>
                </b-card-body>
              </pane>
            </splitpanes>
          </div>
          <div v-else>
            <b-row v-if="invalid">
              <b-col cols="12">
                <!-- <TickZhold /> -->
                <!-- <b-card-header class="text-primary">
                  Your Active Tickets</b-card-header
                >

                <b-card-body class="p-0 mr-2">
                  <b-row>
                    <b-col> <TickInvalid /></b-col>
                  </b-row>
                  <b-row>
                    <b-col> <TickZhold /></b-col>
                  </b-row>
                </b-card-body> -->
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-card-body v-if="chartData" class="p-0">
                  <CalendarSinglepick v-model="selected" :data="chartData" :options="chartOptions"
                    @selectDay="selectedDay" @changeMonth="changeMonth" />
                </b-card-body>
              </b-col>
              <b-col>
                <b-card-body class="px-0">
                  <b-row>
                    <b-col cols="auto" class="mr-auto">
                      <b-navbar toggleable="sm" type="light" variant="light" class="pl-0 bg-transparent"
                        id="eventcalendar-info3">
                        <b-navbar-brand class="text-primary text-right">{{
                          $moment(selected).format("dddd Do MMMM YYYY")
                        }}</b-navbar-brand>
                      </b-navbar>
                      <b-tooltip target="eventcalendar-info3" triggers="hover">Change month or click on day to see the
                        events</b-tooltip>
                    </b-col>
                    <b-col cols="12" md="4" class="mt-2">
                      <b-form-group size="sm">
                        <b-input-group>
                          <b-form-input size="sm" v-model="find" placeholder="Find"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" style="width: auto; padding: 0.25rem 0.6rem" variant="outline-primary"
                              :disabled="!find" @click="find = ''">
                              <i v-if="find" class="fa fa-remove"></i>
                              <i v-if="!find" class="fa fa-search"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-table ref="eventtable" id="eventtable" striped fixed small bordered :items="items" :fields="fields"
                    :filter="find" :per-page="perPage" :current-page="currentPage" class="eventtable gridtable">
                    <template v-slot:cell()="row">
                      <div v-if="row.field.key == 'event'">
                        {{ row.item.eventcode }} ( {{ row.item.description }} )
                      </div>
                      <div v-else>{{ row.value }}</div>
                    </template>
                  </b-table>
                  <b-row class="text-left text-muted small" no-gutters>
                    <b-col v-if="items.length > 0" class="pl-2">Showing {{ items.length }} event(s)</b-col>
                    <b-col v-if="!items.length > 0" class="pl-2">There are no events to display</b-col>
                    <b-col>
                      <b-pagination v-if="items.length > 0" aria-controls="eventtable" v-model="currentPage"
                        :total-rows="items.length" :per-page="perPage" size="sm" align="right"
                        hide-ellipsis></b-pagination>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-col>
            </b-row>
            <b-row v-if="chartOptions" class="mt-2 pl-2">
              <b-col class="legend" cols="4" v-for="(group, index) in criteria.groups" :key="index">
                <div :class="'inline mt-1 border-secondary bg-' + group.bootstrap" @click="toggleGroup(group.id)"></div>
                <span class="text-secondary pl-1" :style="search.group.includes(group.id)
                  ? null
                  : 'text-decoration:line-through'
                  " @click="toggleGroup(group.id)">{{ group.id }}</span>
              </b-col>
            </b-row>
            <b-row class="text-left text-muted small" no-gutters>
              <b-col class="pl-2 mt-2">Click to toggle display</b-col>
            </b-row>
          </div>

          <!-- <b-row v-if="chartData" class="mt-2">
            <b-col class="text-secondary"
              >{{ chartData.total }} event(s) were found.</b-col
            >
          </b-row> -->
        </b-card-body>
      </b-card>
    </div>
    <!-- <DraftInvoiceWizard /> -->
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import * as fs from "file-saver";

import CalendarSinglepick from "@/pages/private/charts/Calendar-singlepick";

import TickInvalid from "@/pages/private/Tiles/TickInvalid";
import TickZhold from "@/pages/private/Tiles/TickZhold";

import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

export default {
  name: "Calendar",
  props: ["tile", "refresh"],
  components: {
    CalendarSinglepick,
    Splitpanes,
    Pane,
    TickInvalid,
    TickZhold,
    // DraftInvoiceWizard,
  },
  async mounted() {
    await this.loadDDL();
    this.$helpers.resizableColumns();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        console.log("watcher refresh");
        // await this.loadChart();
        await this.loadData();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        // await this.loadChart();
        await this.loadData();
      },
    },
  },
  data() {
    return {
      invalid: true,
      onstopclients: [],
      onstopsuppliers: [],
      pane1: 28,
      pane2: 42,
      busy: false,
      busyddl: false,
      search: {
        group: [],
      },
      criteria: {
        groups: [],
      },
      options: {
        title: "Events Diary",
        icon: "fa fa-calendar",
      },
      items: [],
      fields: [
        {
          key: "description",
          label: "Description",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "date",
          label: "Start Date",
          sortable: true,
          sortDirection: "desc",
          formatter: (value, key, item) => {
            let result = "";
            if (value) {
              result = this.$moment(value).format("ddd DD/MM/YYYY");
            }
            return result;
          },
        },
        {
          key: "eventcode",
          label: "Event",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "budgetdescription",
          label: "Budget",
          sortable: true,
          sortDirection: "desc",
        },
        // {
        //   key: "enddate",
        //   label: "End Date",
        //   sortable: true,
        //   sortDirection: "desc",
        // },
      ],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      find: null,
      selected: null,
      defaultData: {
        date: "01/07/2020",
        rows: [],
        total: 0,
      },
      defaultOptions: {
        responsive: true,
        maintainAspectRatio: true,
        title: {
          display: true,
          text: "Cheapflights Data",
        },
        legend: {
          display: true,
          position: "bottom",
        },
      },
      chartData: null,
      chartOptions: null,
    };
  },
  computed: {
    ...mapGetters(["user", "events", "window"]),
    greeting() {
      var myDate = new Date();
      var hrs = myDate.getHours();
      var greet;
      if (hrs < 12) greet = "Good morning";
      else if (hrs >= 12 && hrs <= 17) greet = "Good afternoon";
      else if (hrs >= 17 && hrs <= 24) greet = "Good evening";
      return greet;
    },
  },
  methods: {
    async loadDDL() {
      console.log("welcome loadDDL");
      this.busyddl = true;

      try {
        const clientcheck = await this.$apollo.query({
          query: gql`
            query clients($active: String, $onstop: String) {
              clients(active: $active, onstop: $onstop) {
                slac
                name
              }
            }
          `,
          variables: { active: "true", onstop: "true" },
        });

        this.onstopclients = clientcheck.data.clients;

        // comment back
        // const suppliercheck = await this.$apollo.query({
        //   query: gql`
        //     query suppliers($active: String, $onstop: String) {
        //       suppliers(active: $active, onstop: $onstop) {
        //         blac
        //         name
        //       }
        //     }
        //   `,
        //   variables: { active: "true", onstop: "true" },
        // });

        // this.onstopsuppliers = suppliercheck.data.suppliers;
        // comment back
        let variables = {
          orderby: [["description", "asc"]],
        };

        console.log("variables", variables);

        const response = await this.$apollo.query({
          query: gql`
            query setup_budgets ( $orderby: [[String]] ) {
              setup_budgets ( orderby: $orderby ) {
                id :description
                code
                label
                bootstrap
              }
            }
          `,
          variables,
        });
        this.criteria.groups = response.data.setup_budgets;
        this.search.group = [];
        for (var i = 0; i < this.criteria.groups.length; i++) {
          this.search.group.push(this.criteria.groups[i].id);
        }
        await this.loadData();
      } catch (error) {
        console.log(error);
      }
      this.busyddl = false;
    },
    async loadData(e) {
      this.busy = true;
      if (!e) {
        e = this.$moment().format("YYYY-MM-DD");
      }
      let variables = {
        date: e,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query events_calendar1($date: String) {
              events_calendar1(date: $date) {
                eventcode
                description
                event_at
                budgetcode
                budgetdescription
                bootstrap
              }
            }
          `,
          variables,
        });

        let result = response.data.events_calendar1

        // SINGLE DATASET
        this.chartData = {
          date: this.$moment(e, "YYYY-MM-DD").format("DD/MM/YYYY"),
          rows: [],
          datasets: [
            {
              data: [],
            },
          ],
          total: 0,
        };

        for (var i = 0; i < result.length; i++) {
          this.chartData.rows.push({
            date: this.$moment.unix(result[i].event_at / 1000).format("YYYY-MM-DD"),
            variant: result[i].bootstrap,
            eventcode: result[i].eventcode,
            description: result[i].description,
            budgetdescription: result[i].budgetdescription,
          });

          // let colour = this.criteria.groups.find(
          //   (obj) => obj.id == response.data.events_calendar1[i].budgetdescription
          // );
          // if (colour) {
          //   this.chartData.rows[this.chartData.rows.length - 1].bootstrap =
          //     colour.bootstrap;
          // }
          this.chartData.total = this.chartData.rows.length;
        }
        await this.render();
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
      await this.$emit("refreshed");
    },
    async render() {
      if (this.chartData) {
        this.chartData.datasets[0].data = [];
        for (var i = 0; i < this.chartData.rows.length; i++) {
          let row = this.chartData.rows[i];
          let found = this.search.group.find((o) => o == row.budgetdescription);
          if (found) {
            let item = {
              id: i,
              date: row.date,
              label: row.eventcode,
              variant: row.variant,
              budgetdescription: row.budgetdescription,
              description: row.description,
            };
            this.chartData.datasets[0].data.push(item);
          }
        }

        this.items = [];
        // // PREPARE THE DATA FOR DISPLAY
        this.selected = this.$moment
          .utc(this.chartData.date, "DD/MM/YYYY")
          .toDate();
        this.selectedDay({ date: this.selected });

        this.chartOptions = this.defaultOptions;
      }
    },
    async download(e) {
      this.busy = true;
      if (!e) {
        e = this.$moment().format("YYYY-MM-DD");
      }
      let variables = {
        date: e,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query events_ics($date: String) {
              events_ics(date: $date)
            }
          `,
          variables,
        });

        let icsname = "TP_" + this.$moment(e).format("MMMM") + this.$moment(e).format("YY")
        let data = response.data.events_ics
        console.log("downloaded item", data);
        var blob = new Blob([data], {
          type: "text/calendar;charset=utf-8"
        });
        fs.saveAs(blob, icsname + ".ics");

      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    selectedDay(e) {
      console.log(e);
      if (this.chartData) {
        this.selected = this.$moment.utc(e.date, "DD/MM/YYYY").toDate();
        this.chartData.selected = this.$moment.utc(e.date).format("DD/MM/YYYY");
        this.items = [];
        if (this.chartData.rows.length > 0) {
          let k = 0;
          for (var i = 0; i < this.chartData.rows.length; i++) {
            let row = this.chartData.rows[i];
            if (
              this.$moment(row.date, "YYYY-MM-DD").format("DD/MM/YYYY") ==
              this.$moment(this.selected).format("DD/MM/YYYY")
            ) {
              k = k + 1;
              let found = this.search.group.find((o) => o == row.budgetdescription);
              if (found) {
                let item = {
                  id: k,
                  budgetdescription: row.budgetdescription,
                  eventcode: row.eventcode,
                  description: row.description,
                  date: row.date,
                  bootstrap: row.bootstrap,
                };
                this.items.push(item);
              }
            }
          }
        }
      }
    },
    changeMonth(e) {
      this.selected = this.$moment(e + "/01", "YYYY/MM/DD").toDate();
      this.loadData(this.$moment(this.selected).format("YYYY-MM-DD"));
      this.$emit("change", e);
    },
    toggleGroup(e) {
      if (this.search.group.includes(e)) {
        let id = this.search.group.indexOf(e);
        if (id > -1) {
          this.search.group.splice(id, 1);
        }
      } else {
        this.search.group.push(e);
      }
      this.render();
    },
  },
};
</script>

<style></style>